import { render } from "./z-comments-skelet.vue?vue&type=template&id=e2c42424&scoped=true"
const script = {}

import "./z-comments-skelet.vue?vue&type=style&index=0&id=e2c42424&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2c42424"]])

export default __exports__